import { GroupAdd as InteressentenIcon } from '@mui/icons-material';

import { AppFeature } from '../../components/dcbApp/types';

import { InteressentListScreen } from './list/InteressentListScreen';
import { InteressentDialogForm } from './save/InteressentDialogForm';
import { InteressentViewScreen } from './view/InteressentViewScreen';

export const interessentFeature: AppFeature = {
  path: 'interessenten',
  label: 'Interessenten',
  icon: <InteressentenIcon sx={{ color: 'secondary.main' }} />,
  list: <InteressentListScreen />,
  view: <InteressentViewScreen />,
  dialogs: [<InteressentDialogForm key="interessent-dialog" />],
};
